import React from "react";
import Aux from "../utils/AuxFunctions";
import "../account/Account.css"
import "./AddPost.css"
import Fire from "../config/Fire";
import { withMyDataContext } from "../context/DataProvider";

import ImagePlusIcon from "mdi-react/ImageAddIcon"
import ImageEditIcon from "mdi-react/ImageEditIcon"

import CheckFilledIcon from "mdi-react/CheckCircleIcon"
import CheckBlankIcon from "mdi-react/CircleOutlineIcon"
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon"
import PlusIcon from "mdi-react/PlusIcon"
import MinusIcon from "mdi-react/MinusIcon"
import Colors from "../utils/Colors";
import ButtonLoader from "../utils/Utilities/ButtonLoader"
import ErrorMessage from "../utils/ErrorPages/ErrorMessage"
import Loader from "../utils/Utilities/Loader";
import Embed from "react-embed";
import NumberFormat from "react-number-format";
import LoadingHelper from "../utils/Utilities/LoadingHelper";
import TextInputMaterial from "../utils/Utilities/TextInputMaterial";

class AddPost extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            text: "",
            loading: false,
            selected: 0,
            selectedPhoto: null,
            uploadedPhoto: null,
            errorText: "",
            errorTags: "",
            errorCoins: "",
            coins: 0,
            currentTab: 0,
            hide: false,
            tag: "",
            url: "",
        }
    }


    onSubmit = async () => {

        if (this.state.loading) {
            return;
        }
        if (this.state.text.trim() === "" && (this.state.uploadedPhoto === null || this.state.uploadedPhoto === "")) {
            this.setState({ loading: false, errorText: "Cant be empty" })
            this.setState({ currentTab: 0 })
            return;
        }

        if (this.state.coins < 5) {
            this.setState({ loading: false, errorCoins: "Minimum amount is 5$" })
            this.setState({ currentTab: 2 })
            return
        }

        this.setState({ loading: true, errorText: "" })
        
        try {
            let daysSince = this.props.myDataProvider.getDaysSince()
            await Fire.shared
                .uploadPost(this.props.myDataProvider.user, this.state.text, this.state.uploadedPhoto, this.state.coins, this.state.tag, this.state.hide, this.state.url, daysSince)
                .then((didPost) => {
                    if (didPost) {
                        this.setState({ loading: false })
                        this.props.history.push("/")
                    } else {
                        this.setState({ loading: false, errorText: "an unexpected error occurred" })
                    }
                })
        } catch (error) {
            Aux.handleError(error)
        }
    }

    photoSelectedHandler = (event) => {
        let photo = URL.createObjectURL(event.target.files[0])
        this.setState({ selectedPhoto: photo, uploadedPhoto: event.target.files[0], url: "" })
    }

    handlerSlider = (coins) => {
        this.setState({ coins: coins })
    }

    handleIncrementCoin = (number) => {
        if (this.state.coins + number >= this.props.myDataProvider.coins) {
            this.setState({ coins: this.props.myDataProvider.coins })
        } else if (!this.state.coins && this.props.myDataProvider.coins > 0) {
            this.setState({ coins: number })
        } else if (!this.state.coins) {
            this.setState({ coins: 0 })
        } else {
            this.setState(prevState => ({ coins: prevState.coins + number }));
        }
    }

    handleDecrementCoin = () => {
        if (!this.state.coins || this.state.coins < 0) {
            this.setState({ coins: 0 })
        } else {
            this.setState(prevState => ({ coins: prevState.coins - 1 }));
        }
    }

    handleCoinsSlider = (event) => {
        let num = parseInt(event.target.value, 10)
        this.setState({ coins: num });
    }

    onSelectItem = (hashtag) => {
        if (hashtag === this.state.tag) {
            this.setState({ tag: "", errorCategory: "" })
        } else {
            this.setState({ tag: hashtag, errorCategory: "" })
        }
    }

    deletePhoto = () => {
        this.setState({ selectedPhoto: null, uploadedPhoto: null })
    }

    deleteUrl = () => {
        this.setState({ url: "" })
    }

    goToCoins = () => {
        try {
            this.props.history.push("/account/balance")
        } catch (error) {
            Aux.handleError(error)
        }
    }

    checkIfUrl = () => {
        if (this.state.selectedPhoto)
            return

        var urlRE = new RegExp("([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?([^ ])+");
        const output = this.state.text.match(urlRE)
        if (output?.length > 0) {
            this.setState({ url: output[0], selectedPhoto: null, uploadedPhoto: null })
        }
    }

    renderTextInput = () => {
        return (
            <div>
                <h2 style={{ marginBottom: 20 }}>Create a post</h2>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", overflow: "hidden", marginBottom: 10, backgroundColor: "#f7f7f7", borderRadius: 10, padding: 10 }}>
                    {this.state.hide ?
                        <div style={{ display: "flex", alignItems: "center" }}>
                            {Aux.showHidden(40)}
                            <span style={{ marginLeft: 10 }}>Anonymous</span>
                        </div> :
                        this.props.myDataProvider.user ?
                            <div style={{ display: "flex", alignItems: "center", overflow: "hidden" }}>
                                {Aux.showAvatar(40, this.props.myDataProvider.user.avatar, this.props.myDataProvider.user.username || "Unknown")}
                                <span style={{ marginLeft: 10, overflow: "hidden", textOverflow: "ellipsis" }}>{this.props.myDataProvider.user.username || "Unknown"}</span>
                            </div>
                            : <Loader></Loader>
                    }

                    <div style={{ marginLeft: 5, display: "flex", justifyContent: "center", alignItems: "center", color: this.state.hide ? Colors.mainColor : "grey", cursor: "pointer" }} onClick={() => this.setState({ hide: !this.state.hide })} className="button-hover">
                        <span style={{ marginRight: 5 }}>Hide</span>
                        {this.state.hide ? <CheckFilledIcon /> : <CheckBlankIcon />}
                    </div>
                </div>
                <div>
                    {/* {error ? <span className="login-error">{error}</span> : null} */}
                    <ErrorMessage text={this.state.errorText}></ErrorMessage>

                    <TextInputMaterial onBlur={this.checkIfUrl}
                        type="text" rows="5" placeholder="What's on your mind?" multiline={true}
                        style={{marginBottom:10}}
                        styleInput={{ resize: "none", height: "100%", padding: 10, backgroundColor:"transparent" }}
                        onChange={(e) => {
                            this.setState({ text: e.target.value });
                        }}/>
                    {this.state.url ?
                        <div>
                            <Embed key={this.state.url} url={this.state.url}></Embed>
                            <div style={{ /* backgroundColor: Colors.red, */ display: "flex", alignItems: "center", justifyContent: "flex-end", marginTop: 5 /* padding: "7px 10px", borderRadius: 5, color: "white", cursor: "pointer" */ }}
                                onClick={this.deleteUrl} >
                                {/* <DeleteIcon></DeleteIcon> */}
                                <span className="text-hover" style={{ color: Colors.red, cursor: "pointer" }}>Delete preview</span>
                            </div>
                        </div> : null}
                    {this.state.selectedPhoto ?
                        <div>
                            <img style={{ width: "100%", borderRadius: 5, objectFit: "cover", }}
                                src={this.state.selectedPhoto ? this.state.selectedPhoto : Aux.TemporaryImage} alt="avatar">
                            </img>
                            <div style={{ /* backgroundColor: Colors.red, */ display: "flex", alignItems: "center", justifyContent: "flex-end", marginTop: 5 /* padding: "7px 10px", borderRadius: 5, color: "white", cursor: "pointer" */ }}
                                onClick={this.deletePhoto} >
                                {/* <DeleteIcon></DeleteIcon> */}
                                <span className="text-hover" style={{ color: Colors.red, cursor: "pointer" }}>Delete Photo</span>
                            </div>
                        </div> : null}
                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
                        <div style={{ display: "flex", }}>
                            <label htmlFor="file" className="custom-file-upload">
                                <div className="next-button button-hover" style={{ backgroundColor: "transparent", color: Colors.mainColor, borderRadius: 5, display: "flex", alignItems: "center", height: 30, borderWidth:2, borderColor:Colors.mainColor, borderStyle:"solid" }}>
                                    {this.state.selectedPhoto ? <ImageEditIcon size={30}/> : <ImagePlusIcon size={30}/>}
                                    <span style={{ marginLeft: 10, color: Colors.mainColor, fontSize:10, fontWeight:"bold" }}>{this.state.selectedPhoto ? "Change photo" : "Add photo"}</span> 
                                </div>
                            </label>
                            <input id="file" type="file" className="file-upload" onChange={this.photoSelectedHandler} />
                        </div>
                        <div>
                            <ButtonLoader
                                text="Next"
                                style={{ backgroundColor: Colors.mainColor, padding: "15px 35px" }}
                                onClick={this.nextPage}>
                            </ButtonLoader>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    onChanged(text) {

        let tag = text.replace(/[^a-zA-Z0-9_*$]/g, '')
        this.setState({ tag: tag, });
    }

    renderHashtag = () => {
        return (
            <div >
                <div className="reversed-button-hover" onClick={this.previousPage} style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
                    <ChevronLeftIcon></ChevronLeftIcon>
                    <h2 style={{ marginLeft: 10 }}>Add a hashtag</h2>
                </div>
                {/* {error ? <span className="login-error">{error}</span> : null} */}
                <ErrorMessage text={this.state.errorTags}></ErrorMessage>
                <div style={{ padding: "20px 0px", display: "flex", justifyContent: "center", borderRadius: 10, backgroundColor: "#f9f9f9", }}>
                    <span style={{ color: Colors.darkText, fontWeight: "bold" }}>#{this.state.tag}</span>
                </div>
                <div style={{ marginTop: 10, marginBottom: 20 }}>
                    <span style={{ color: "#777", fontSize:14}}>You can only add one hashtag to this post</span>
                    <div style={{ display: "flex", alignItems: "center", margin: "10px 0" }}>
                        {/* <span style={{fontSize:23}}>#{this.state.tag}</span> */}
                        <TextInputMaterial  maxLength={30} type="text" placeholder="Insert hashtag" value={this.state.tag}
                            style={{width:"100%"}}
                            onChange={(e) => this.onChanged(e.target.value)}
                        />
                        {/* <span style={{color:Colors.mainColor, marginLeft:10}} className="text-hover">Add</span> */}
                        {/* <PlusIcon style={{color: Colors.mainColor, marginLeft:10, backgroundColor:Colors.mainColor, color:"white", borderRadius:8}} className="button-hover"/> */}
                    </div>
                </div>
                <span style={{ color: "#777", fontSize:14 }}>Suggested hashtags</span>
                <div style={{ display: "flex", flexWrap: "wrap",/*  border: "1px solid #ccc", maxHeight: 300,*/  marginTop: 10 }}>

                    {Aux.temporaryTags.map((item, index) => {
                        //const selected = item.hashtag === this.state.tag
                        return (

                            <div key={index} className="category-item" style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", padding: "5px 5px" }}
                                onClick={() => this.onSelectItem(item.hashtag)}>
                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    {/* {item.id === "uncategorized" ? <div style={{ marginLeft: 20 }} /> : <img src={item.image} alt={item.text} style={{ width: 30, height: 30, objectFit: "contain", marginLeft: 20, marginRight: 10 }}></img>} */}
                                    <span style={{ color: "#aaa", fontSize: 14 }}>#{item.hashtag}</span>
                                </div>
                                <PlusIcon size={20} style={{ color: Colors.mainColor }} />
                            </div>
                        )
                    })}
                </div>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", margin: 20, marginRight: 0 }}>
                    <ButtonLoader
                        text="Next"
                        style={{ backgroundColor: Colors.mainColor }}
                        onClick={this.nextPage}>
                    </ButtonLoader>
                </div>
            </div>
        )
    }


    renderCoins = () => {
        return (
            <div >
                <div className="reversed-button-hover" onClick={this.previousPage} style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
                    <ChevronLeftIcon></ChevronLeftIcon>
                    <h2 style={{ marginLeft: 10 }}>Amount to spend</h2>
                </div>

                {/* {error ? <span className="login-error">{error}</span> : null} */}
                <ErrorMessage text={this.state.errorCoins}></ErrorMessage>
                <div style={{ marginTop: 30 }}>
                    <div style={{ display: "flex", alignItems: "flex-start", flexDirection: "column", marginBottom: 50 }}>
                        <span>Available Balance</span>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: 10 }}>
                            <h3>${this.props.myDataProvider.coins}</h3>
                            <PlusIcon
                                onClick={this.goToCoins}
                                className="coins-icon"
                                style={{ backgroundColor: Colors.mainColor, color: "white", marginLeft: 10, padding: 2 }}>

                            </PlusIcon>
                        </div>

                    </div>
                    <div >
                        <span style={{ display: "flex", alignSelf: "flex-start", margin: "20px 0" }}>Enter Amount</span>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", margin: "5px 0" }}>

                            <div onClick={this.handleDecrementCoin}>
                                <MinusIcon className="coins-icon" ></MinusIcon>
                            </div>
                            <NumberFormat
                                placeholder="0,00"
                                className="add-coins-input"
                                value={this.state.coins}
                                thousandSeparator={true} prefix={'$'}
                                allowNegative={false}
                                decimalScale={0}
                                // style={{textAlign:"right", backgroundColor:"rgb(248, 248, 248)"}}
                                onValueChange={(values) => {
                                    const { floatValue } = values;
                                    var myValue = floatValue
                                    var currentCoins = this.props.myDataProvider.user?.coins || 0
                                    if (floatValue > currentCoins) {
                                        myValue = currentCoins
                                    }
                                    this.setState({ coins: myValue })
                                }} />
                            <div onClick={() => this.handleIncrementCoin(1)}>
                                <PlusIcon className="coins-icon" ></PlusIcon>
                            </div>

                        </div>
                    </div>
                    <div className="slidecontainer" style={{ marginTop: 10 }}>
                        <input type="range"
                            // defaultValue={0} 
                            min={0}
                            max={this.props.myDataProvider.coins}
                            step={1}
                            value={this.state.coins}
                            className="slider"
                            onChange={this.handleCoinsSlider}
                        />
                    </div>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", flexWrap:"wrap" }}>
                        <span className="coins-add-value" onClick={() => this.handleIncrementCoin(5)}>+5$</span>
                        <span className="coins-add-value" onClick={() => this.handleIncrementCoin(25)}>+25$</span>
                        <span className="coins-add-value" onClick={() => this.handleIncrementCoin(100)}>+100$</span>
                        <span className="coins-add-value" onClick={() => this.handleIncrementCoin(500)}>+500$</span>
                    </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center", marginTop: 30, marginBottom: 20 }}>
                    <ButtonLoader
                        text="Post"
                        loading={this.state.loading}
                        style={{ backgroundColor: Colors.mainColor, width: "100%" }}
                        onClick={this.onSubmit}>
                    </ButtonLoader>
                </div>
            </div>
        )
    }

    nextPage = () => {
        if (this.state.currentTab <= 1)
            this.setState((prevState) => ({ currentTab: prevState.currentTab + 1 }));
    }

    previousPage = () => {
        if (this.state.currentTab > 0)
            this.setState((prevState) => ({ currentTab: prevState.currentTab - 1 }));
    }

    render() {
        return (
            <div style={{ width: "100%" }}>
                <section className="container"  >
                    
                    {this.props.myDataProvider.user ?
                        <div>
                               
                            {this.state.currentTab === 0 ?
                                <div>
                                    <this.renderTextInput />
                                </div>
                                :
                                this.state.currentTab === 1 ?
                                    <this.renderHashtag />
                                    :
                                    <this.renderCoins />
                            }
                        </div>
                        : <LoadingHelper />}
                </section></div>
        );
    }
}

export default withMyDataContext(AddPost);